import React from 'react';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';
import { Button } from 'reactstrap';
import { NOTIFY_UPCOMING_SCAN } from '../queries';
import { displaySuccess, displayError, logAmplitudeEvent } from '../utilities';

const NotifyUpcomingScan = ({
  bookingId,
  disabled,
  size,
  color,
  style,
  block
}) => {
  return (
    <Mutation
      mutation={NOTIFY_UPCOMING_SCAN}
      onCompleted={() => displaySuccess('Scan notification sent successfully')}
      onError={e => displayError(e)}
    >
      {(notifyScan, { loading }) => (
        <Button
          size={size}
          color={color}
          block={block}
          style={style}
          disabled={disabled || loading}
          onClick={() => {
            notifyScan({ variables: { bookingId } });
            logAmplitudeEvent('Notify_Upcoming_Scan', { bookingId }, true);
          }}
        >
          {loading ? 'Sending...' : 'Send Scan Reminder'}
        </Button>
      )}
    </Mutation>
  );
};

NotifyUpcomingScan.propTypes = {
  bookingId: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  size: PropTypes.string,
  color: PropTypes.string,
  style: PropTypes.object,
  block: PropTypes.bool
};

NotifyUpcomingScan.defaultProps = {
  disabled: false,
  size: 'sm',
  color: 'primary',
  style: {},
  block: false
};

export default NotifyUpcomingScan;
